'use client';

import React from 'react';
import { cn } from '@/utils';
import { MicrophoneIcon } from './icons';

/** Microphone + animated waveform shown while the user is in listening mode. */
export const ListeningIndicator: React.FC = () => (
  <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 transform items-center gap-2">
    <MicrophoneIcon size={40} className="text-brand-primary" />
    {/* Audio Waveform Animation */}
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className={cn(
            'animate-pulse rounded-full bg-brand-primary',
            i === 0 && 'h-12 w-12',
            i === 1 && 'h-16 w-10',
            i === 2 && 'h-12 w-10 rotate-180',
            i === 3 && 'h-16 w-10 rotate-180',
            i === 4 && 'h-12 w-10 rotate-180',
          )}
          style={{
            animationDelay: `${i * 0.1}s`,
            animationDuration: '1s',
          }}
        />
      ))}
    </div>
  </div>
);
